import { TrendsCount } from "../Utils/TableHeadlist";
import { useGetDashboardTotalCountQuery } from "../../../../Service/dashboard";
import { Col, Row } from "react-bootstrap";
import TableBox from "../component/TableBox";
import DonutBox from "../component/DonutBox";
import ChartBoxSmall from "../component/ChartBoxSmall";
import Chart from "../component/Chart";
import Feedback from "./Feedback";
import MimoCount from "../mimo-analytics/MimoCount";
import { BsThreeDots } from "react-icons/bs";
import DonutChart from "../component/DonutChart";
import Table from "../component/Table";
import UserChart from "../component/UsersChart";
import UserJourney from "../component/UserJourney";
import { Reset } from "../../../../store/async-actions/digitalmarketing/header";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

function MimoAnalytics() {
  const CountList = TrendsCount;
  const { data } = useGetDashboardTotalCountQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  let dashboardCountList = [];

  if (data) {
    const totalCountValue = Object.values(data);
    dashboardCountList = TrendsCount.map((item, index) => {
      item.list = totalCountValue[index];
      return item;
    });
  }
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(Reset());    
  }, [dispatch]);

  return (
    <>
      <h3 className="f-20 fw-600">Trends </h3>
      {/* <MimoCount CountList={TrendsCount} />  */}
      <Row className="mt-3 mb-3"> 
        <Col className="mb-3" md={12} lg={7}>
          <MimoCount CountList={TrendsCount} />
          <Row className="mt-3">
            {/* <Col className="mb-3" md={12} lg={6}>
              <DonutBox element={<DonutChart />} title="Word Analysis" />
            </Col> */}
            <Col className="mb-3" md={12} lg={12}>
              <DonutBox element={<DonutChart />} title="Story Analysis" />
            </Col>
          </Row>
        </Col>
        <Col className="mb-3" md={12} lg={5}>
          <Feedback />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col className="mb-3" md={12} lg={7}>
          <TableBox element={<Table />} title="Contact List" />
        </Col>
        <Col className="mb-3" md={12} lg={5}>
          <UserChart element={<UserJourney />} title="User Journey" />
        </Col>
      </Row>
    </>
  );
}

export default MimoAnalytics;
